export const scrollToFilter = () => {
    const searchForm = document.getElementById("search-form");
    if (searchForm) {
        searchForm.scrollIntoView({
            behavior: "smooth"
        });
        
    } else if (window.location.href.includes('search-results')) {
        // scroll to the top of the search results page
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    } else {
        window.location.href = "/#search-form";
    }
}